en:
  value_required: This field is mandatory
  create: Create
  close: Close
  cancel: Cancel
  save: Save
  test: Test
  delete: Delete
  min_pwd_length: Minimum 8 characters
  required: This value cannot be empty
  confirm: Confirm
  confirm_delete: Confirm delete
  copy: Copy
  email_required: Please enter a valid email address
  back: Back
  continue: Continue
  error: Error
  dismiss: Dismiss

cs:
  value_required: Toto pole je povinné
  create: Vytvořit
  close: Zavřít
  cancel: Zrušit
  save: Uložit
  test: Otestovat
  delete: Smazat
  min_pwd_length: Minimálně 8 znaků
  required: Toto pole nesmí být prázdné
  confirm: Potvrdit
  confirm_delete: Potvrďte smazání
  copy: Vytvořit kopii
  email_required: Zadejte platnou emailovou adresu
  back: Zpět
  continue: Pokračovat
  error: Chyba
  dismiss: Zavřít
